import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLazyGetNotificationsCountQuery } from "../../../middleware/notificationApi";

import { useAction } from "../../../hooks/actions";
import "./style.css";
import { PushEvent } from "./PushEvent";
import alarmSound from "../../../sounds/AlarmNotification.wav";

// Initialize audio outside the component
const alarmAudio = new Audio(alarmSound);
alarmAudio.preload = "auto";

export const NotificationPopUp = ({
  customopen,
  setmessageCount,
  setopenMessage,
}) => {
  const [notifications, setNotifications] = useState([]);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [prevNotificationsCount, setPrevNotificationsCount] = useState(0);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const soundIntervalRef = useRef(null);
  const intervalRef = useRef(null);
  const { t } = useTranslation();
  const { setIsErrorSubmit } = useAction();

  const [getNotificationcount, { error: errorNotifcount }] =
    useLazyGetNotificationsCountQuery();

  const playNotificationSound = () => {
    try {
      alarmAudio.currentTime = 0;
      alarmAudio.play().catch((e) => {
        console.error("Audio playback error:", e);
      });
    } catch (e) {
      console.error("Audio error:", e);
    }
  };

  const startNotificationInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      getNotificationcount({ notificationTypes: [9] }).then((data) => {
        const newCount = data.data;
        setPrevNotificationsCount(notificationsCount);
        setNotificationsCount(newCount);
        setmessageCount(newCount);
      });
    }, 1000);
  };

  const startSoundInterval = () => {
    if (soundIntervalRef.current) {
      clearInterval(soundIntervalRef.current);
    }

    playNotificationSound();
    soundIntervalRef.current = setInterval(() => {
      playNotificationSound();
    }, 5000);
  };

  const stopSoundInterval = () => {
    if (soundIntervalRef.current) {
      clearInterval(soundIntervalRef.current);
      soundIntervalRef.current = null;
    }
    alarmAudio.pause();
    alarmAudio.currentTime = 0;
  };

  useEffect(() => {
    startNotificationInterval();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      stopSoundInterval();
    };
  }, []);

  useEffect(() => {
    if (
      (notificationsCount > prevNotificationsCount &&
        !open &&
        intervalRef.current) ||
      customopen
    ) {
      setOpen(true);
    }

    /*if (notificationsCount > 0 && !open) {
      startSoundInterval();
    } else {
      stopSoundInterval();
    }*/
  }, [notificationsCount, prevNotificationsCount, open, customopen]);

  useEffect(() => {
    if (open) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      //stopSoundInterval();
    } else {
      startNotificationInterval();
      /*if (notificationsCount > 0) {
        startSoundInterval();
      }*/
    }
  }, [open, notificationsCount]);

  const handleCloseModal = () => {
    setopenMessage(false);
    setOpen(false);
  };

  return (
    <>
      {open && (
        <PushEvent
          open={open}
          setOpen={handleCloseModal}
          setPrevNotificationsCount={setPrevNotificationsCount}
          setNotificationsCount={setNotificationsCount}
          stopSoundInterval={stopSoundInterval}
          startSoundInterval={startSoundInterval}
        />
      )}
    </>
  );
};
